import Vue from 'vue'
import App from './App.vue'
import router from './router/routerSite.js'
import store from './store'

window.$ = window.jQuery = require('jquery');

import 'bootstrap'

//bootstrapvue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap-vue/dist/bootstrap-vue.css'
//end

Vue.config.productionTip = false;
router.beforeEach(async(to, from, next) => {
    // Redirect to Dashboard if logged in
    if (localStorage.getItem('userData') !== null) {
        // let userData = JSON.parse(localStorage.getItem('userData'));
        // if (userData.user.role == 'Admin') {
            window.location.href = "/admin/dashboard";
        // }
    }
    // ##Redirect to Dashboard if logged in
    document.title = process.env.VUE_APP_NAME + ' : ' + to.meta.title;
    next();
});

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
}).$mount('#app')